import gqlValidateCampaignReferral from 'services/api/advocacy/validateCampaignReferral';
import gqlAddToPromotion from 'services/api/advocacy/addToPromotion';
import gqlActiveClientCampaigns from 'services/api/advocacy/activeClientCampaigns';
import utilityApi from 'services/api/utility';

// Referee killswitch — gates the referee UI + GraphQL transport.
const isRefereeGraphQLEnabled = () => Sephora.configurationSettings.refereeLandingPageEnhancements?.isEnabled === true;
// Referrer killswitch — GraphQL-only, no REST/SDN fallback.
const isReferrerGraphQLEnabled = () => Sephora.configurationSettings.referrerLandingPageEnhancements?.isEnabled === true;

const advocacyApi = {
    validateCampaignReferral: payload =>
        isRefereeGraphQLEnabled() ? gqlValidateCampaignReferral(payload) : utilityApi.getAdvocacyLandingPageContentSDN(payload),
    addToPromotion: (payload, referralToken) =>
        isRefereeGraphQLEnabled() ? gqlAddToPromotion(payload, referralToken) : utilityApi.addToPromotion(payload, referralToken),
    activeClientCampaigns: payload => (isReferrerGraphQLEnabled() ? gqlActiveClientCampaigns(payload) : Promise.resolve(null))
};

export default advocacyApi;
